export default __webpack_public_path__ + "static/proxima-nova-500-81a112c1f9d37df798b5fcfdf9084a86.woff2";